import React, { useState, useEffect, useRef } from 'react';
import './DisclaimerPopup.css';
import { ReactComponent as Pig } from '../Components/Assets/toolbox.svg';

export const DisclaimerPopup = ({ onAgree, onClose }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [isScrollComplete, setIsScrollComplete] = useState(false);
  const contentRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    const contentElement = contentRef.current;
    if (contentElement) {
      const scrollHeight = contentElement.scrollHeight;
      const clientHeight = contentElement.clientHeight;
      const scrollDuration = 15000; // 15 seconds for full scroll

      if (scrollHeight > clientHeight) {
        setIsScrollComplete(false);
        const scrollTimer = setTimeout(() => {
          let startTime = null;

          const animateScroll = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const progress = timestamp - startTime;
            const scrollPercent = Math.min(progress / scrollDuration, 1);
            contentElement.scrollTop = scrollPercent * (scrollHeight - clientHeight);
            
            if (progress < scrollDuration) {
              animationRef.current = requestAnimationFrame(animateScroll);
            } else {
              setIsScrollComplete(true);
            }
          };

          animationRef.current = requestAnimationFrame(animateScroll);
        }, 500);

        return () => {
          clearTimeout(scrollTimer);
          if (animationRef.current) {
            cancelAnimationFrame(animationRef.current);
          }
        };
      } else {
        // If content doesn't need scrolling, enable immediately
        setIsScrollComplete(true);
      }
    }
  }, []);

  const handleAgreeClick = () => {
    if (isChecked) {
      onAgree();
    }
  };

  return (
    <div className="disclaimer-overlay">
      <div className="disclaimer-popup">
        <div className="pig-container">
          <Pig className="disclaimer-pig" />
        </div>
        <h3>Experimental Build Notice</h3>
        <h6>This file contains original animations, 3D assets, and early-stage gameplay logic as a proof of concept. It is an illustrative, non-functional demonstration, requiring further testing and development. <strong> The contents of this file may crash, break saves, or conflict with your operating system. </strong>By downloading, you understand and agree:</h6>
        <div className="disclaimer-content" ref={contentRef}>
          <ul>
            <li>This is a <strong>non-functional technical demonstration to be used as reference.</strong></li>
            <li><strong>It is not a finished product,</strong> and may require advanced technical skills to stabilize.</li>
            <li>It is not suitable for redistribution or gameplay and will be used for personal development, learning, or educational purposes only.</li>
            <li>Any optimizations or functional implementation require additional development and testing.</li>
            <li>You assume all responsibility for reverse-engineering or adapting it for your use-case.</li>
            <li>You will not share or distribute this file as functional content.</li>
            <li>This content is not affiliated with or endorsed by any commercial game engine.</li>
            <li><i className="icon-alert"></i><strong>No support provided:</strong> This is part of an ongoing research and development project. By keeping or opening this file, you agree to the terms above and accept all liability to include any associated risks.</li>
          </ul>
        </div>
        <div className="disclaimer-checkbox">
          <input
            type="checkbox"
            id="agree-checkbox"
            checked={isChecked}
            onChange={() => isScrollComplete && setIsChecked(!isChecked)}
            disabled={!isScrollComplete}
          />
          <label htmlFor="agree-checkbox" className={!isScrollComplete ? 'disabled-label' : ''}>
            {isScrollComplete 
              ? "I Assume All Risks - Download Anyway" 
              : "Please read all terms (scroll will complete automatically)"}
          </label>
        </div>
        <div className="disclaimer-buttons">
          <button className="disagree-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className={`agree-btn ${!isChecked ? 'disabled' : ''}`}
            onClick={handleAgreeClick}
            disabled={!isChecked || !isScrollComplete}
          >
            Download
          </button>
        </div>
      </div>
    </div>
  );
};